export const filterMixin = {
  methods: {
    filterList(list, string) {
      return list.filter((_, index) =>
        matchesString(list[index], string)
      )
    },
  },
}

function matchesString(object, string) {
  if (string.length == 0) {
    return true
  }

  let values = getObjectValues(object)

  for (var i = 0; i < values.length; i++) {
    if (typeof values[i] == 'string' &&
      (values[i].indexOf(string.toLowerCase()) > -1)) {
      return true
    } else if (values[i] == string) {
      return true
    }
  }
  return false
}

function getObjectValues(object) {
  if (object instanceof Object) {
    return Object.values(object).map(value => getObjectValues(value)).flat()
  } else if (object instanceof Array) {
    return object.map(value => getObjectValues(value))
  } else {
    return typeof object == 'string' ? object.toLowerCase() : object
  }
}